import type { createBrowserRouter } from 'react-router-dom';

type DataRouter = ReturnType<typeof createBrowserRouter>;

let appRouter: DataRouter | null = null;

// The data router is created inside <App/> (it depends on the user's roles), so
// non-React callers such as the redux async middleware cannot reach it through
// hooks. Registering it here lets them trigger a client-side navigation.
export const registerAppRouter = (router: DataRouter) => {
  appRouter = router;
};

/**
 * SPA navigation usable from outside the React tree (e.g. the redux async
 * middleware). Uses the data router's navigate so we get a client-side
 * transition instead of a full page reload. Falls back to a hard navigation if
 * the router has not been registered yet.
 */
export const navigateApp = (path: string) => {
  if (appRouter) {
    void appRouter.navigate(path);
  } else {
    window.location.href = path;
  }
};
